import { combineReducers } from "redux";
import commonReducer from "../../commonReducer/commonReducer";
import drivingMarketParamsReducer from "../common/params";
import allTimeHighLow from "./allTimeHighLow";
export default combineReducers({
    reducersData: allTimeHighLow,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
